enum Currency {
  USD = "USD",
  EUR = "EUR",
  GBP = "GBP",
  JPY = "JPY",
  AUD = "AUD",
  CAD = "CAD",
  CHF = "CHF",
  HKD = "HKD",
  SGD = "SGD",
  SEK = "SEK",
  ARS = "ARS",
  BRL = "BRL",
  CNY = "CNY",
  COP = "COP",
  CZK = "CZK",
  DKK = "DKK",
  HUF = "HUF",
  ILS = "ILS",
  INR = "INR",
  KRW = "KRW",
  MXN = "MXN",
  NOK = "NOK",
  NZD = "NZD",
  PLN = "PLN",
  RUB = "RUB",
  THB = "THB",
  TRY = "TRY",
  TWD = "TWD",
  UAH = "UAH",
  ZAR = "ZAR",
}

// eslint-disable-next-line no-redeclare
namespace Currency {
  export const names = {
    [Currency.USD]: "$",
    [Currency.EUR]: "€",
    [Currency.GBP]: "£",
    [Currency.JPY]: "¥",
    [Currency.AUD]: "$ (AUD)",
    [Currency.CAD]: "$ (CAD)",
    [Currency.CHF]: "CHF",
    [Currency.HKD]: "$ (HKD)",
    [Currency.SGD]: "$ (SGD)",
    [Currency.SEK]: "kr",
    [Currency.ARS]: "$ (ARS)",
    [Currency.BRL]: "R$",
    [Currency.CNY]: "¥ (CNY)",
    [Currency.COP]: "$ (COP)",
    [Currency.CZK]: "Kč",
    [Currency.DKK]: "kr",
    [Currency.HUF]: "Ft",
    [Currency.ILS]: "₪",
    [Currency.INR]: "₹",
    [Currency.KRW]: "₩",
    [Currency.MXN]: "$ (MXN)",
    [Currency.NOK]: "kr",
    [Currency.NZD]: "$ (NZD)",
    [Currency.PLN]: "zł",
    [Currency.RUB]: "₽",
    [Currency.THB]: "฿",
    [Currency.TRY]: "₺",
    [Currency.TWD]: "$ (TWD)",
    [Currency.UAH]: "₴",
    [Currency.ZAR]: "R",
  } as any;

  export const display = (currency: Currency) => {
    return names[currency] || currency;
  };

  export const defaultValue = Currency.USD;
}

export { Currency };
